// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__22g61nCY{height:300px;position:relative}.index_content__22g61nCY{height:100%;width:100%}.index_loading__22g61nCY{position:absolute;top:0;right:0;left:0;bottom:0;display:flex;justify-content:center;align-items:center}.index_loader__22g61nCY{width:50px;padding:8px;aspect-ratio:1;border-radius:50%;background:#25b09b;--_m:conic-gradient(transparent 10%,#000),linear-gradient(#000,#000 0) content-box;-webkit-mask:var(--_m);mask:var(--_m);-webkit-mask-composite:source-out;mask-composite:subtract;animation:index_l3__22g61nCY 1s linear infinite}@keyframes index_l3__22g61nCY{to{transform:rotate(1turn)}}", ""]);
// Exports
exports.locals = {
	"root": "index__22g61nCY",
	"content": "index_content__22g61nCY",
	"loading": "index_loading__22g61nCY",
	"loader": "index_loader__22g61nCY",
	"l3": "index_l3__22g61nCY"
};
module.exports = exports;
